<template>
  <div class="plans">
    <h1>考试记录</h1>
    <div class="content">
      <div class="allsocre">
        <p class="scoreinfo">{{ title }}考试记录</p>
      </div>
      <a-spin :spinning="examListSpinning">
        <table class="table table-bordered">
          <tr>
            <td class="infobg" width="15%">试卷名</td>
            <td class="infobg" width="15%">答题时间</td>
            <td class="infobg" width="10%">答题时长</td>
            <td class="infobg" width="10%">总题数</td>
            <td class="infobg" width="10%">做题数</td>
            <!-- <td class="infobg" width="10%">正确题数</td> -->
            <td class="infobg" width="10%">考试次数</td>
            <td class="infobg" width="10%">原始分数</td>
            <td v-if="MessAge === '1'" class="infobg" width="10%">操作</td>
          </tr>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ item.paperName }}</td>
            <td>{{ item.createDate }}</td>
            <td>{{ item.duration }}</td>
            <td>{{ item.totalQuestion }}</td>
            <td>{{ item.finishedQuestion }}</td>
            <!-- <td>{{ item.correctQuestion }}</td> -->
            <td>{{ item.seq }}</td>
            <td>
              <span v-if="item.assess === 1 && item.marked !== 2">待批改</span>
              <span v-else>{{ item.score }}</span>
            </td>
            <td v-if="MessAge === '1'">
              <a-button @click="returnLook(item.id)" size="small" style="background: #2caf7a;color: #fff;border: 1px solid #2caf7a;">回看</a-button>
            </td>
          </tr>
        </table>
      </a-spin>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlanList",
  data: function () {
    return {
      title: null,
      data: [],
      examListSpinning: true,
      MessAge:''
    };
  },
  mounted() {
    console.log(this.$route.query);
    if (this.$route.query.subjectId) {
      this.getInfo(this.$route.query.subjectId);
    }
  },
  methods: {
    returnLook(id){
      const recordId='/biz/exam/reviewUrl?recordId='+id
      this.axios.get(recordId).then(res=>{
        if(res.code === 200){
          window.open(res.result)
        }

      })
    },
    getInfo(subjectId) {
      this.examListSpinning = true;
      this.axios
        .get(`/biz/exam/record`, { params: { subjectId: subjectId } })
        .then((res) => {
          console.log(res);
          if (res.success) {
            console.log(res.result.results);
            this.MessAge = res.message
            this.data = res.result.results;
            let title =
              res.result.results.length > 0 ? res.result.results[0].subjectName : "无";
            this.title = title;
            this.examListSpinning = false;
          }
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.plans {
  margin-bottom: 30px;

  h1 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .content {
    background: #fff;
    padding: 28px;
    min-height: 300px;

    .liinfo {
    }

    .li-top {
      font-size: 16px;
      font-weight: bold;
      color: $bgColor;
      margin-bottom: 20px;
    }

    .table td {
      background: #fff;
      text-align: center;
      line-height:30px;

      &.infobg {
        background: $bgColor;
        font-weight: bold;
        color: #fff;
      }
    }

    .scorename {
      font-size: 34px;
      text-align: center;
      line-height: 56px;
      background: url('../../../assets/images/hg.png') no-repeat center 10px;
    }

    .allsocre {
      background: $bgcontent;
      padding: 28px;
      margin-bottom: 30px;
    }

    .scoreinfo {
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/examinationrecord/components/PlanList.vue